<template>
  <div class="advantage-center">
    <h5>OUR ADVANTAGES</h5>
    <div class="line"></div>
    <div class="advantage-cards">
      <div  v-for="(item) in icons" class="card-item">
        <!-- <img
          style="width: 80px; height: 80px"
          :src="image.cur"
          alt=""
        /> -->
        <!-- <svg-icon style="display:block; margin: 40px auto 30px;"size='80' name="home_ic_TrackingVisualization"></svg-icon> -->
        <svg-icon style="display:block; margin: 40px auto 30px;"size='80' :name="item.icon"></svg-icon>
        <span>{{item.text}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/public/SvgIcon.vue';
    // import a from "../../../assets/img/opaBg.png"
export default {
  components: { SvgIcon },
  data() {
    return {
      icons: [
        {   
            icon:'home_ic_airports_select2',
            text: 'Main departure airports in China'
        },
        {   
            icon:'home_ic_arilines__select',
            text: '50+ BSA airline'
        },
        {   
            icon:'home_ic_gas_select',
            text: '300+ GSA live rates'
        },
        {   
            icon:'home_ic_trucking_select',
            text: '3000+ trucking networks connection'
        },
        {   
            icon:'home_ic_efficient_select',
            text: 'Efficient，simple'
        },
        {   
            icon:'home_ic_TrackingVisualization_select',
            text: 'Tracking Visualization'
        },
        {   
            icon:'home-IC-space_select',
            text: 'Space confirmed, Price Availa'
        },
        {   
            icon:'home_ic_menber_select',
            text: 'WCA Member protection'
        },
       
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.advantage-center {
  width: $centerWidth;
  margin: 0 auto;
  text-align: center;
  h5 {
    font-size: 30px;
    color: #333333;
    line-height: 40px;
    text-stroke: 1px #333333;
  }
}
.line {
  @include dividingLine();
  margin: 10px auto 40px;
}

.advantage-cards {
  display: flex;
  flex-wrap: wrap;
  height: 450px;
  justify-content: space-between;
  align-content: space-between;
  .card-item {
    width: 297px;
    height: 210px;

    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #2e5eb9;
    transition:all .2s ease-in-out;

    // background: linear-gradient(#fff 50%,#2e5eb9 0);
    // background-size: 100% 200%;
    // background-position: 0 0;
    &:hover {
      transform: scale(1.11);
      background: #2e5eb9;
      // background-position: 0 100%;
      span{
        color: #fff !important;
      }
      
    }
  }
  img {
    margin: 40px auto 30px;
  }
  span {
    font-size: 16px;

    color: #333333;
    line-height: 21px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/reception/indexPage/Advantages.vue